import * as React from 'react'
import { CSSProperties } from 'react';

const styling: React.CSSProperties = {
    border: '1px solid transparent',
    fontSize: '35px',
    cursor: 'pointer',
    width: '25px',
    height: '25px',
    textAlign: 'center',
    color: 'darkgray',
    zIndex: 9999,
    top: 0,
    right: 0,
    position: 'absolute'
}

type Props = {
    closeAction: (evt: any) => void,
    top?: string;
    right?: string;
    position?: string;
}

export class ShopCloseX extends React.Component<Props, any>{
    render() {
        var offset = {
            top: this.props.top || styling.top,
            right: this.props.right || styling.right,
            position: this.props.position || styling.position
        }
        var finalStyling = Object.assign({}, styling, offset);

        return (
            <div style={finalStyling} onClick={this.props.closeAction}>&times;</div>
        );
    }
}

